export default __webpack_public_path__ + "static/media/fridge1-after1-1920w.68fa45ae.avif";